import { cubeCustomColors } from "../../../tailwind.config";

export function getGridSelectColors(theme: string | undefined) {
  const isDark = theme === "dark";
  return {
    control: {
      backgroundColor: isDark ? cubeCustomColors.cubeBaseDark[700] : "#FFFFFF",
      border: `1px solid ${isDark ? cubeCustomColors.cubeBaseDark[600] : "#DADADA"}`,
      color: isDark ? "#C7C7C7" : "#585858",
    },
    icon: { color: isDark ? "#C7C7C7" : "#585858" },
    menuPaper: {
      backgroundColor: isDark
        ? cubeCustomColors.cubeBaseDark[700]
        : cubeCustomColors.cubeBase[700],
      border: `1px solid ${isDark ? cubeCustomColors.cubeBaseDark[600] : "#DADADA"}`,
      color: isDark ? "#C7C7C7" : "#585858",
    },
    menuItemHover: {
      backgroundColor: isDark ? cubeCustomColors.cubeBaseDark[600] : "#CDCDCD",
    },
  };
}
